var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ranking)?_c('ranking',{key:_vm.ranking.id,attrs:{"ranking":_vm.ranking,"filter":_vm.$options.filter}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }